// src/api/carApi.js
import api from './index';


export const getGptCarList = (params = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/gptCarpage_gpt_submai', params);
};


export const getGptAPICarList = (params = {}) => {
  return api.post('/testapi/gateway/new_gateway_controller/frontend-api/gpt_gpt_api_Carpage_gpt_submai', params);
};

export const getGrokCarList = (params = {}) => {
  return api.post('/testapi/gateway/new_gateway_controller/frontend-api/grokCarpage_grok_submain', params);
};


export const getSoraCarList = (params = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/soraCarpage_sora_submain', params);
  };


export const getMJCarList = (params = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/mjCarpage_mj_submain', params);
};


export const getCCarList = (params = {}) => {
    return api.post('/testapi/gateway/new_gateway_controller/frontend-api/claudeCarpage_claude_submain', params);
};